import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Play } from "@untitledui/icons";
import { useTranslation } from "react-i18next";

export const StartNode = ({ data }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const label = (data?.label as string) || t('workflows.editor.defaultLabels.start');
    return (
        <div className="rounded-lg bg-utility-success-50 border-2 border-utility-success-500 shadow-md min-w-[120px]">
            <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-utility-success-500" />
            <div className="flex items-center gap-2 px-3 py-2">
                <Play className="size-4 text-utility-success-600" />
                <span className="text-sm font-semibold text-utility-success-700">{label}</span>
            </div>
        </div>
    );
};
